import { ClerkProvider, useAuth, useUser } from '@clerk/clerk-react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  console.warn('Missing REACT_APP_CLERK_PUBLISHABLE_KEY');
}

/**
 * AuthLayout wraps authenticated routes with ClerkProvider.
 * Only these routes have access to Clerk auth context.
 * Public routes are NOT wrapped by this component.
 */
export default function AuthLayout() {
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    </ClerkProvider>
  );
}

/**
 * AuthGuard checks authentication status and redirects if needed.
 * Shows loading state only within auth routes (not globally).
 */
function AuthGuard({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  // Show minimal loading only for auth routes
  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return children;
}
